import * as React from "react";
import { useContext, useEffect, useState } from "react";

import { useAuth } from "../../../contexts/AuthContext.jsx";
import { alertV2 } from "../../../api/index.js";

import InfoDialog from "./InfoDialog.jsx";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
function CloseAlert({
  suspected,
  openModal,
  setOpenModal,
  onSuccess,
  data,
  alertId,
}) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const [actionCompleted, setActionCompleted] = React.useState("Yes");
  const [actionWork, setActionWork] = React.useState("");
  const [additionalComment, setAdditionalComment] = React.useState("");
  const [other, setOther] = React.useState("");
  const [maintainedComponent, setMaintainedComponent] = React.useState("");
  const [maintenanceCost, setMaintenanceCost] = React.useState("");
  const [confirmedIssue, setConfirmedIssue] = React.useState([]);
  const { email } = useAuth();
  const [attachment, setAttachment] = useState("");
  const [unplannedDowntime, setUnplannedDowntime] = useState("");
  const [manHourSaved, setManHourSaved] = useState("");
  const [attachmentName, setAttachmentName] = useState("");
  const [description, setDescription] = useState("");
  const [openInfo, setOpenInfo] = useState(false);
  const [infoTitle, setInfoTitle] = useState("");
  const handleChangeValue = (e) => {
    setTextValue(e.target.value);
  };
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  const handleOpenInfo = (info) => {
    setOpenInfo(true);
    setDescription(info.description);
    setInfoTitle(info.title);
  };
  useEffect(() => {
    if (data) {
      setActionCompleted(data.action_completed);
      setUnplannedDowntime(data.unplanned_downtime);
      setManHourSaved(data.man_hour_saved);
      setAdditionalComment(data.additional_comment);
      setActionWork(data.action_work);
      setConfirmedIssue(data.confirmed_issue);
      setOther(data.confirmed_issue);
      setAttachmentName(data.attachment);
      setMaintenanceCost(data.maintenance_cost);
      setMaintainedComponent(data.maintained_component);
    } else {
      setActionCompleted("Yes");
      setAdditionalComment("");
      setManHourSaved("");
      setUnplannedDowntime("");
      setActionWork("");
      setConfirmedIssue([]);
      setOther("");
      setAttachmentName("");
    }
  }, [data]);
  const submitHandler = async () => {
    if (actionCompleted === "Yes") {
      if (
        !maintainedComponent ||
        !unplannedDowntime ||
        !manHourSaved ||
        !maintenanceCost
      ) {
        toast.error("Please fill in all required fields");
        return;
      }
    }
    const payload = {
      email: email,
      event_details: `This is ${
        actionCompleted === "Yes" ? "Valid" : "Invalid"
      } Alert`,
      event_name: "Response",
      event_action: actionCompleted === "Yes" ? "Closed" : "Invalid",
      alert_id: alertId,
      action_detail: JSON.stringify({
        action_completed: actionCompleted,
        unplanned_downtime: unplannedDowntime,
        man_hour_saved: manHourSaved,
        maintained_component: maintainedComponent,
        maintenance_cost: parseInt(maintenanceCost),
        action_name: actionCompleted === "Yes" ? "Closed" : "Invalid",
        action_work: actionWork,
        additional_comment: additionalComment,
      }),
    };

    const res = await alertV2.addLogAction(alertId, payload, attachment);
    onSuccess();
    setAttachmentName("");
    setOpenModal(false);
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  useEffect(() => {
    if (actionCompleted === "No") {
      setMaintainedComponent("-");
    } else {
      setMaintainedComponent("");
    }
  }, [actionCompleted]);

  function InputText(props) {
    return <input type="text" style={{ width: "250px" }} />;
  }
  const handleAttachment = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setAttachment(undefined);
      return;
    }
    setAttachmentName(e.target.files[0].name);
    setAttachment(e.target.files[0]);
  };

  return (
    <div>
      <Modal show={open} size={"lg"} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert Update - Close Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              fontSize: "13px",
              position: "relative",
              padding: "20px",
            }}
          >
            <div>
              1. Is this a valid Alert? <sup>*</sup>
            </div>
            <div
              className="form-check form-check-inline"
              style={{ marginLeft: "10px" }}
            >
              <input
                className="form-check-input"
                type="radio"
                name={"actionCompleted"}
                checked={actionCompleted === "Yes"}
                onChange={(e) => setActionCompleted(e.target.value)}
                id="defaultRadio1"
                value="Yes"
              />
              <label className="form-check-label" htmlFor="defaultRadio1">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                value="No"
                checked={actionCompleted === "No"}
                onChange={(e) => setActionCompleted(e.target.value)}
                name={"actionCompleted"}
                id="defaultRadio2"
              />
              <label className="form-check-label" htmlFor="defaultRadio2">
                No
              </label>
            </div>
            <InfoDialog
              openModal={openInfo}
              setOpenModal={setOpenInfo}
              description={description}
              title={infoTitle}
            ></InfoDialog>
            {/*<div style={{ marginLeft: "15px", position: "relative" }}>*/}
            {/*  <div className="form-control"></div>*/}
            {/*  {data ? <div className="overlay-disable"></div> : null}*/}
            {/*</div>*/}
            <div mt={1}>
              <ol start={2} style={{ paddingLeft: "11px" }}>
                <li>
                  Please share with us the details of the maintenance works
                  done. We recommend providing additional context. This will
                  help us in providing better recommendations in the future.
                </li>
              </ol>
            </div>
            <div style={{ position: "relative" }}>
              <div style={{ display: "flex", marginLeft: "10px" }}>
                <div>
                  <div style={{ height: "30px" }}>
                    Maintained/Repaired Component <sup>*</sup>
                  </div>
                  <div
                    style={{ height: "30px", cursor: "pointer" }}
                    onClick={() => {
                      handleOpenInfo({
                        title: "Unplanned Downtime Avoided",
                        description:
                          "The amount of hours saved by preventing unexpected breakdowns in your machine",
                      });
                    }}
                  >
                    Unplanned Downtime Avoided <sup>*</sup>{" "}
                  </div>
                  <div
                    style={{ height: "30px", cursor: "pointer" }}
                    onClick={() => {
                      handleOpenInfo({
                        title: "Maintenance Cost",
                        description:
                          "The total cost for maintenance or replacement activities",
                      });
                    }}
                  >
                    Maintenance Cost <sup>*</sup>{" "}
                  </div>
                  <div
                    style={{ height: "30px", cursor: "pointer" }}
                    onClick={() => {
                      handleOpenInfo({
                        title: "Man-hour Saved",
                        description:
                          "The total of hours saved by avoiding unplanned downtime by unexpected breakdown in the machine. Meaning if the machine broke down, how many hours of work will the workers need to do",
                      });
                    }}
                  >
                    Man-hour Saved <sup>*</sup>{" "}
                  </div>
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div style={{ height: "30px" }}>
                    <input
                      style={{
                        height: "23px",
                        width: "250px",
                        fontSize: "13px",
                        fontFamily: `"Source Sans Pro", sans-serif`,
                      }}
                      disabled={actionCompleted === "No"}
                      value={maintainedComponent}
                      onChange={(e) => setMaintainedComponent(e.target.value)}
                      type="text"
                    />
                  </div>
                  <div style={{ height: "30px" }}>
                    <input
                      style={{
                        height: "23px",
                        width: "100px",
                        fontSize: "13px",
                        fontFamily: `"Source Sans Pro", sans-serif`,
                      }}
                      disabled={actionCompleted === "No"}
                      value={unplannedDowntime}
                      onChange={(e) => setUnplannedDowntime(e.target.value)}
                      type="number"
                    />
                  </div>
                  <div style={{ height: "30px" }}>
                    <input
                      style={{
                        height: "23px",
                        width: "100px",
                        fontSize: "13px",
                        fontFamily: `"Source Sans Pro", sans-serif`,
                      }}
                      disabled={actionCompleted === "No"}
                      value={maintenanceCost}
                      onChange={(e) => setMaintenanceCost(e.target.value)}
                      type="number"
                    />
                  </div>
                  <div style={{ height: "30px" }}>
                    <input
                      style={{
                        height: "23px",
                        width: "100px",
                        fontSize: "13px",
                        fontFamily: `"Source Sans Pro", sans-serif`,
                      }}
                      disabled={actionCompleted === "No"}
                      value={manHourSaved}
                      onChange={(e) => setManHourSaved(e.target.value)}
                      type="number"
                    />
                  </div>
                </div>
              </div>
              {data ? <div className="overlay-disable"></div> : null}
            </div>
            <div mt={1}>3. Any additional comments.</div>
            <div style={{ padding: "5px 15px", position: "relative" }}>
              <textarea
                disabled={!!data}
                value={actionWork}
                placeholder="Please share more details here."
                onChange={(e) => setActionWork(e.target.value)}
                cols="30"
                rows="4"
                style={{
                  width: "100%",
                  resize: "none",
                  padding: "10px",
                  fontFamily: '"Source Sans Pro", sans-serif',
                  fontSize: "13px",
                }}
              ></textarea>
            </div>
            {!data ? (
              <div mt={1}>
                <input
                  type="file"
                  onChange={handleAttachment}
                  style={{ display: "none" }}
                  id="input-file-action"
                />
                <label
                  className="upload-docs"
                  htmlFor="input-file-action"
                  style={{
                    cursor: "pointer",
                    border: "1px solid grey",
                    width: "270px",
                  }}
                >
                  <div style={{ paddingTop: "3px", paddingLeft: "6px" }}>
                    <i className="fa fa-upload"></i>{" "}
                    {attachmentName
                      ? attachmentName
                      : "Upload Maintenance Document"}
                  </div>
                </label>
              </div>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="theme" onClick={submitHandler}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default CloseAlert;
